import { create } from "zustand";
import { getJobById, getJobs, reRunJob } from "src/services/settings.service";
import { SettingJobProps } from "./interface/setting-job.interface";
import { QueryTagPIJob, ResponseSettingJob, SettingJobStatusEnum } from "src/entity/settings/job";

export const settingJobStore = create<SettingJobProps>((set) => ({
  data: [],
  loading: false,
  error: null,

  loadingEachJob: {},

  loadingJobStatus: false,
  dataJobById: null,
  getSettingJob: async () => {
    set(() => ({ loading: true }));
    try {
      const response = await getJobs();
      const configLoadingJobs: Record<string, boolean> = {};
      const data = response.data?.data ?? [];
      for (const item of data) {
        configLoadingJobs[item._id] = item.status === SettingJobStatusEnum.RUNNING ? true : false;
      }
      set(() => ({
        data,
        loadingEachJob: configLoadingJobs,
      }));
    } catch (error) {
      console.error(error);
    } finally {
      set(() => ({ loading: false }));
    }
  },
  getJobById: async (_id: string) => {
    set(() => ({ loadingJobStatus: true }));
    try {
      const response = await getJobById(_id);
      const responseData = response.data.data;

      set((state) => {
        const tmpData = [...state.data];
        tmpData.forEach((item, index) => {
          if (item._id === _id) tmpData.splice(index, 1, responseData);
        });
        return {
          dataJobById: responseData,
          data: tmpData,
          loadingEachJob: {
            ...state.loadingEachJob,
            [_id]: responseData.status === SettingJobStatusEnum.RUNNING ? true : false,
          },
        };
      });
    } catch (error) {
      console.error(error);
    } finally {
      set(() => ({ loadingJobStatus: false }));
    }
  },
  reRunJob: async (_id: string, query?: QueryTagPIJob) => {
    try {
      await reRunJob(_id, query);
    } catch (error) {
      console.error(error);
    } finally {
    }
  },
  setLoadingJobs: async (_id: string, value: boolean) => {
    set((state) => ({
      loadingEachJob: {
        ...state.loadingEachJob,
        [_id]: value,
      },
    }));
  },
  mergeData: (object: ResponseSettingJob) => {
    set((state) => {
      const tmpData = [...state.data];
      tmpData.forEach((item, index) => {
        if (item._id === object._id) {
          tmpData.splice(index, 1, object);
        }
      });

      return {
        data: tmpData,
      };
    });
  },
}));
